import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import Grid from '@material-ui/core/Grid';
import { Typography } from '@material-ui/core';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import ContextoService from '../../services/Contexto';
import EnumService from '../../services/Enum';
import { errors } from '../../services/API';

import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import Title from '../../components/Title/Title';
import Text from '../../components/Inputs/Text/Text';
import SelectOption from '../../components/Inputs/Select/Select';
import Toast from "../../components/Toast/Toast";
import Loading from '../../components/Loading/Loading';

import ButtonsForm from '../../forms/Buttons/ButtonsForm';

import { 
    isBlank, 
    isBlankHelperText, 
    isNotNumber, 
    isNumberHelperText
} from '../../helper/ValidationHelper';
import { numberMask } from '../../helper/MaskHelper';
import { filterPersistence } from '../../helper/ParseStateHelper';

import { Layout } from '../../layouts/private/Private';

class Form extends Component {
    constructor(props) {
        super(props);
        this.state = {
            context: {
                id: this.props.match.params.id,
                name: '',
                code: '',
                type: '',
                ordemExibicao: '',
                value: '',
                legenda: '',
                grupoExibicao: '',
            },
            errors: {
                name: false,
                type: false,
                ordemExibicao: false,
                grupoExibicao: false,
            },
            helpers: {
                name: null,
                type: null,
                ordemExibicao: null,
                grupoExibicao: null,
            },
            typeInitial: '',
            loadingButtonSave: false,
            loading: true,
            history: {
                path: null,
                state: null,
            },
            optionsType: [],
            optionsGrupoExibicao: [],
        };
    }

    // INPUTS
    handleChange = e => {
        this.setState({
            context: {...this.state.context, [e.target.name]: e.target.name === 'ordemExibicao' ? numberMask(e.target.value) : e.target.value },
            errors: {...this.state.errors, [e.target.name]: false },
            helpers: {...this.state.helpers, [e.target.name]: null }
        });
    };

    handleChangeLegenda = editor => {
        this.setState({
            ...this.state,
            context: {
                ...this.state.context,
                legenda: editor.getData()
            }
        })
    }

    // DECLARAÇÃO DE REFERÊNCIA DOS COMPONENTES
    setToast = t => this.Toast = t;

    // VALIDAÇÃO
    isValid = () => {
        if ( isBlank(this.state.context.name) || isBlank(this.state.context.type) || isBlank(this.state.context.ordemExibicao) || isNotNumber(this.state.context.ordemExibicao)
                || isBlank(this.state.context.grupoExibicao) ) {
            this.setState({ 
                errors: {
                    name: isBlank(this.state.context.name) ? true : false,
                    type: isBlank(this.state.context.type) ? true : false,
                    ordemExibicao: isBlank(this.state.context.ordemExibicao) || isNotNumber(this.state.context.ordemExibicao) ? true : false,
                    grupoExibicao: isBlank(this.state.context.grupoExibicao) ? true : false,
                },
                helpers: {
                    name: isBlank(this.state.context.name) ? isBlankHelperText() : null,
                    type: isBlank(this.state.context.type) ? isBlankHelperText() : null,
                    ordemExibicao: isBlank(this.state.context.ordemExibicao) ? isBlankHelperText() : isNotNumber(this.state.context.ordemExibicao) ? isNumberHelperText() : null,
                    grupoExibicao: isBlank(this.state.context.grupoExibicao) ? isBlankHelperText() : null,
                },
            })
            return false
        }
        return true
    }

    // SALVAR
    handleSubmit = () => {
        this.setState({ loadingButtonSave: true });

        const formIsValid = this.isValid()
        
        if ( !formIsValid ) {
            this.setState({ loadingButtonSave: false });
            return
        }       

        const context = {
            tipo: this.state.context.type,
            variavel: this.state.context.name,
            valor: this.state.typeInitial === this.state.context.type ? this.state.context.value : null,
            ordemExibicao: this.state.context.ordemExibicao,
            legenda: this.state.context.legenda,
            agrupamento: this.state.context.grupoExibicao,
        } 
        
        ContextoService.edit(this.state.context.id, context)
            .then(res => {
                this.Toast.setState({
                    message: {
                        message: "Variável de Contexto Atualizada com Sucesso.",
                        type: "success",
                        open: true
                    }
                });

                setTimeout(() => this.handleBack(), 1000);
            })
            .catch(error => {
                const e = errors(error);
                this.Toast.setState({
                    message: {
                        message: e.message,
                        type: e.type,
                        open: true
                    }
                })
                this.setState({ loadingButtonSave: false });
            })
    }

    async componentDidMount() {     
        const tipos = await EnumService.listarTiposVariavel().then(res => res.data);
        const grupos = await EnumService.listarAgrupamentos().then(res => res.data);
        
        this.setState({ 
            optionsType: [...tipos], 
            optionsGrupoExibicao: [...grupos], 
            history: filterPersistence(this.props.location) 
        });
        
        ContextoService.find(this.state.context.id)
            .then(res => {
                this.setState({
                    context: {
                        id: res.data.id,
                        name: res.data.variavel,
                        code: res.data.codigo, 
                        type: res.data.tipo,
                        ordemExibicao: res.data.ordemExibicao,
                        value: res.data.valor,
                        legenda: res.data.legenda,
                        grupoExibicao: res.data.agrupamento,
                    },
                    typeInitial: res.data.tipo,
                    loading: false,
                });
            })
            .catch(err => {
                this.Toast.setState({
                    message: {
                        message: "Não Foi Possível Buscar a Variável de Contexto para Edição.",
                        type: 'error',
                        open: true
                    }
                })

                this.setState({ loading: false })
            })
    }

    handleBack = () => {        
        this.props.history.push({
            pathname: this.state.history.path ? `${this.state.history.path}` : `/admin/contexto/listagem`,
            state: {
                history: {
                    state: this.state.history.state
                }
            }
        });
    }

    render () {
        const page = 'Editar Variável';
        const links = [
            {
                path: null,
                name: 'Configurações'
            },
            {
                path: '/admin/contexto',
                name: 'Contexto'
            },
            {
                path: { 
                    pathname: this.state.history.path ? `${this.state.history.path}` : `/admin/contexto/listagem`,
                    state: {
                        history: {
                            state: this.state.history.state
                        }
                    }
                },
                name: 'Listagem'
            }
        ];

        return (
            <Layout>
                <Toast parentRef={this.setToast} />
                <Grid container >
                    <Grid item xs={12}>
                        <Breadcrumbs links={links} active={page} />
                    </Grid>
                </Grid>

                <Title>{page}</Title>

                { this.state.loading ? 
                    <Loading />
                :
                    <>
                        <Grid container spacing={3} alignItems='center'>
                            <Grid item sm={12} lg={3}>
                                <Text
                                    required
                                    name="name"
                                    label="Nome da Variável"
                                    value={this.state.context.name}
                                    error={this.state.errors.name}
                                    onChange={this.handleChange}
                                    helperText={this.state.helpers.name}
                                />
                            </Grid>
                            <Grid item sm={12} lg={1}>
                                <Text
                                    required
                                    name="code"
                                    label="Código da Variável"
                                    value={this.state.context.code}
                                    disabled
                                />
                            </Grid>
                            <Grid item sm={12} lg={3}>
                                <SelectOption 
                                    required
                                    name="type"
                                    label="Tipo de Variavel"
                                    options={this.state.optionsType}
                                    value={this.state.context.type}
                                    error={this.state.errors.type}
                                    onChange={this.handleChange}
                                    hiddenblank="true"
                                    helperText={this.state.helpers.type}
                                />
                            </Grid>
                            <Grid item sm={12} lg={2}>
                                <SelectOption 
                                    required
                                    name="grupoExibicao"
                                    label="Grupo de Exibição"
                                    options={this.state.optionsGrupoExibicao}
                                    value={this.state.context.grupoExibicao}
                                    error={this.state.errors.grupoExibicao}
                                    onChange={this.handleChange}
                                    helperText={this.state.helpers.grupoExibicao}
                                />
                            </Grid>
                            <Grid item sm={12} lg={2}>
                                <Text
                                    required
                                    name="ordemExibicao"
                                    label="Ordem de Exibição"
                                    value={this.state.context.ordemExibicao}
                                    error={this.state.errors.ordemExibicao}
                                    onChange={this.handleChange}
                                    helperText={this.state.helpers.ordemExibicao}
                                />
                            </Grid>
                        </Grid>

                        <Grid container spacing={3} alignItems='center'>
                            <Grid item sm={12} lg={1}>
                                <Typography variant="body2" display="inline" style={{ fontSize: 12, color: 'rgba(0, 0, 0, 0.54)' }}>
                                    Texto Informativo:
                                </Typography>
                            </Grid>
                            <Grid item sm={12} lg={9}>
                                <CKEditor
                                    editor={ClassicEditor}
                                    data={this.state.context.legenda}
                                    config={{
                                        toolbar: [],
                                        language: 'pt-br',
                                    }}
                                    onChange={(event, editor) => this.handleChangeLegenda(editor)}
                                />
                            </Grid>
                        </Grid>

                        <Grid container spacing={3} alignItems='center'>
                            <ButtonsForm 
                                onClick={this.handleSubmit} 
                                onBack={this.state.history.path ? () => this.handleBack() : null} 
                                loading={this.state.loadingButtonSave} 
                            />
                        </Grid>
                    </>
                }
            </Layout>
        )
    }
}

export default withRouter(Form);